import { useTranslation } from 'react-i18next';
export function useTranslationProject() {
    const { t } = useTranslation('project');
    return { tproject: t };
}
